
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { CreateTechniqueForm } from './CreateTechniqueForm';

interface CreateTechniqueDialogProps {
  onCreationSuccess?: () => void;
  className?: string; // Add className prop to the interface
}

export function CreateTechniqueDialog({ onCreationSuccess, className }: CreateTechniqueDialogProps) {
  const [open, setOpen] = React.useState(false);

  const handleSuccess = () => {
    setOpen(false);
    if (onCreationSuccess) {
      // Ensure the onCreationSuccess callback is called to refresh the techniques list
      setTimeout(() => {
        onCreationSuccess();
      }, 500); // Small delay to ensure database operations complete
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className={`gap-2 ${className || ''}`}>
          <Plus className="h-4 w-4" />
          Create Technique
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Create New Technique</DialogTitle>
        </DialogHeader>
        <CreateTechniqueForm 
          onSuccess={handleSuccess} 
          onCancel={() => setOpen(false)} 
        />
      </DialogContent>
    </Dialog>
  );
}
